module.exports = __webpack_public_path__ + "img/Gramatica_teologhiceasca_trad_Amfilohie_Hotiniul_Iasi_1795_f1v.1194a686.jpg";